var $d737296cedcdee9f$exports = {};
$d737296cedcdee9f$exports = {
  "removeButtonLabel": "\u5220\u9664",
  "removeDescription": "\u6309\u4E0B\u201C\u5220\u9664\u201D\u4EE5\u5220\u9664\u6807\u8BB0\u3002"
};
export { $d737296cedcdee9f$exports as default };